import { Box, useMediaQuery, useTheme } from "@mui/material";
import CustomerMissingReportDesktop from "../components/desktop/customer-missing-report/CustomerMissingReportDesktop";
import { CustomerDatabaseStore } from "../../store/main/CustomerDatabaseStore";
import { useEffect } from "react";
import CustomerMissingReportMobile from "../components/mobile/customer-missing-report/CustomerMissingReportMobile";

const CustomerMissing = () => {
  const { decodeToken } = CustomerDatabaseStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    decodeToken();
  }, []);
  return (
    <>
      <Box p={2}>
        {isMobile ? (
          <CustomerMissingReportMobile />
        ) : (
          <CustomerMissingReportDesktop />
        )}
      </Box>
    </>
  );
};

export default CustomerMissing;
